import React from 'react';

import styles from './AvailablePurchaseOrders.css';
import Results from './Results';
import SearchForm from './SearchForm';

const AvailablePurchaseOrders = ({ activeCrew, dropdowns, form, loading, locationEnabled, onFormUpdate, purchaseOrders, onPurchaseOrderClick }) => (
  <div className={styles.container}>
    <SearchForm
      dropdowns={dropdowns}
      form={form}
      loading={loading}
      onFormUpdate={onFormUpdate}
    />
    <Results
      activeCrew={activeCrew}
      className={styles.results}
      locationEnabled={locationEnabled}
      purchaseOrders={purchaseOrders}
      onPurchaseOrderClick={onPurchaseOrderClick}
    />
  </div>
);

export default AvailablePurchaseOrders;
